<template>
    <div v-show="visible">
        <el-dialog title="导入人员" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="820px">    
            
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item   prop="type" label="名单类型">
                    <el-select v-model="form.type" clearable placeholder="请选择" style="width:270px;">
                        <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item   prop="" label="选择人员">
                    <div style="text-align: center">
                        <el-transfer
                            style="text-align: left;"
                            v-model="directSuperiors"
                            filterable
                            :left-default-checked="leftDefaultChecked"
                            :right-default-checked="rightDefaultChecked"
                            :titles="['人员数据源', '选中人员']"
                            :button-texts="['', '']"
                            :format="{
                                noChecked: '${total}',
                                hasChecked: '${checked}/${total}'
                            }"
                            @change="handleChange"
                            :data="data">
                            <div slot-scope="{ option }">{{ option.label }}</div>
                        </el-transfer>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return {
                visible: false,
                data: [],
                directSuperiors:[],
                leftDefaultChecked:[],
                rightDefaultChecked:[],
                renderFunc(h, option) {
                    return <div>{ option.label }</div>;
                },
                rules: {
                    type: [
                        { required: true, message: '请选择名单类型', trigger: 'blur' }
                    ]
                },
                form:{
                    type:"",
                    deptId:""
                },
                types:[{
                    value: '01',
                    label: '犯罪嫌疑人'
                },{
                    value: '02',
                    label: '重点关注人员'
                },{
                    value: '03',
                    label: 'VIP访客'
                }]
            };
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                this.directSuperiors = [];
                this.data=[],
                this.form.deptId=deptId;
                this.getPersonnel();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //获取人员数据
            getPersonnel(){
                let url  = this.queryPersonnelUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("人员列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.data = res.data.personnels; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 // 过滤人员，人员不存在去除，存在保留
                let selectKeyArry=new Array();
                for(let i=0;i<this.directSuperiors.length;i++){
                    let selectKey = this.directSuperiors[i];
                    for( let j=0;j<this.data.length;j++){
                         let key = this.data[j].key;
                         if(key == selectKey){
                             selectKeyArry.push(selectKey);
                             break;
                         }
                    }
                }
                this.directSuperiors=selectKeyArry;
                //重新赋值
                if(this.directSuperiors.length == 0){
                    this.$commonFn.showTip("人员不可为空",3); 
                }else{
                    // 通过key获取文本值，并赋值给父级窗口
                    let identityCardArr=new Array();
                    let keyArr = this.directSuperiors;
                    let name = "";
                    for(var i = 0;i < this.data.length;i++){
                        let key = this.data[i].key;
                        for(var j=0;j < keyArr.length;j++){
                            if(key == keyArr[j]){
                                identityCardArr.push(this.data[i].identityCard);
                            }
                        }
                    }
                    
                    this.$refs['form'].validate((valid) => {
                        if(valid){
                            let url = this.importUserUrl;
                            let data = {
                                deptId:this.form.deptId,
                                type:this.form.type,
                                identityCard:identityCardArr.join(",")
                            };
                            this.apiPost(url, data).then((res) => {
                                if(res.status === 200){
                                    this.$commonFn.showTip(res.message,1);
                                    this.visible=false;
                                    this.$parent.getData();
                                }else{
                                    this.$commonFn.showTip(res.message,3);
                                }
                            }, (err) => {
                                console.log(err);
                            });
                        }
                    });
                }

            },
             handleChange(value, direction, movedKeys) {
                console.log(value, direction, movedKeys);
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/name/UserTransfer.vue